import { render, staticRenderFns } from "./roomGameResult.vue?vue&type=template&id=944778b4&lang=pug&"
import script from "./roomGameResult.vue?vue&type=script&lang=js&"
export * from "./roomGameResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports